
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import Auth from '@/pages/Auth';

const AppLogin = () => {
  const { user } = useAuth();

  // Redirect to app dashboard if already logged in
  if (user) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-juv-cream-white to-juv-soft-blush safe-area-top safe-area-bottom">
      {/* App Header */}
      <div className="text-center py-8 px-6">
        <h1 className="apple-headline text-juv-deep-chestnut mb-2">
          JUV App
        </h1>
        <p className="apple-body text-juv-deep-chestnut/70">
          Access your credits, book treatments, and track your glow journey.
        </p>
      </div>

      {/* Auth Component */}
      <div className="px-4">
        <Auth />
      </div>

      {/* Back to Website Link */}
      <div className="text-center mt-8 px-6">
        <Link 
          to="/" 
          className="apple-nav-link"
        >
          ← Back to JUV Website
        </Link>
      </div>
    </div>
  );
};

export default AppLogin;
